import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, ArrowRight, ShieldCheck, Cpu } from 'lucide-react';

export default function Login() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();
        // Simulate login
        navigate('/platform/dashboard');
    };

    return (
        <div className="min-h-screen bg-[#0A3B5C] flex items-center justify-center p-6 relative overflow-hidden">
            {/* Background patterns */}
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-accent/20 rounded-full blur-[100px] -mr-64 -mt-64" />
            <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-energy-blue/10 rounded-full blur-[100px] -ml-64 -mb-64" />

            <div className="max-w-md w-full animate-fade-in relative z-10">
                <div className="text-center mb-12">
                    <div className="inline-flex items-center gap-4 mb-8 bg-white/5 p-4 rounded-3xl border border-white/10 shadow-2xl backdrop-blur-md">
                        <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center p-2">
                            <img
                                src={`${import.meta.env.BASE_URL}images/logo.svg`}
                                alt="CIAC Group"
                                className="w-full h-auto"
                            />
                        </div>
                        <div className="flex flex-col text-left">
                            <span className="text-white font-bold tracking-tight text-xl leading-none">CIAC Group</span>
                            <span className="text-white/60 text-[10px] uppercase tracking-widest mt-1">Plataforma Operacional</span>
                        </div>
                    </div>
                    <h1 className="text-3xl font-black text-white tracking-tighter mb-4">Bienvenido al Futuro <br /> de la Energía</h1>
                    <p className="text-white/60 text-sm">Ingrese sus credenciales para acceder al monitoreo centralizado.</p>
                </div>

                <div className="bg-white rounded-[3rem] p-10 shadow-3xl border border-white/20 backdrop-blur-xl">
                    <form onSubmit={handleLogin} className="space-y-6">
                        <div className="space-y-2">
                            <label className="text-xs font-black uppercase tracking-widest text-[#0A3B5C]/50 flex items-center gap-2 px-1">
                                <Mail size={14} /> Correo Corporativo
                            </label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-accent/20 focus:border-accent outline-none transition-all placeholder:text-slate-300 font-medium"
                                placeholder="usuario@ciacgroup.cl"
                            />
                        </div>

                        <div className="space-y-2">
                            <div className="flex justify-between px-1">
                                <label className="text-xs font-black uppercase tracking-widest text-[#0A3B5C]/50 flex items-center gap-2">
                                    <Lock size={14} /> Contraseña
                                </label>
                                <a href="#" className="text-[10px] font-bold text-accent uppercase tracking-widest hover:text-accent-dark transition-colors">¿Olvidó su clave?</a>
                            </div>
                            <input
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl focus:ring-2 focus:ring-accent/20 focus:border-accent outline-none transition-all placeholder:text-slate-300 font-medium"
                                placeholder="••••••••"
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-[#0A3B5C] text-white py-5 rounded-2xl font-black text-sm uppercase tracking-[0.2em] shadow-xl shadow-[#0A3B5C]/20 hover:bg-[#185A82] transition-all flex items-center justify-center gap-3 active:scale-[0.98]"
                        >
                            Acceder al Sistema
                            <ArrowRight size={18} />
                        </button>
                    </form>

                    <div className="mt-10 pt-10 border-t border-slate-50 grid grid-cols-2 gap-4">
                        <div className="flex flex-col items-center text-center gap-2">
                            <div className="w-10 h-10 rounded-xl bg-accent/10 flex items-center justify-center text-accent">
                                <ShieldCheck size={20} />
                            </div>
                            <span className="text-[9px] uppercase font-bold text-slate-400 tracking-widest">Seguridad SSL</span>
                        </div>
                        <div className="flex flex-col items-center text-center gap-2">
                            <div className="w-10 h-10 rounded-xl bg-energy-blue/10 flex items-center justify-center text-energy-blue">
                                <Cpu size={20} />
                            </div>
                            <span className="text-[9px] uppercase font-bold text-slate-400 tracking-widest">IA Monitoreo</span>
                        </div>
                    </div>
                </div>

                <div className="mt-12 text-center">
                    <p className="text-white/40 text-[10px] uppercase font-bold tracking-[0.3em]">
                        © {new Date().getFullYear()} CIAC Energy SpA. Control Panel v2.0
                    </p>
                </div>
            </div>
        </div>
    );
}
